/* eslint-disable react/display-name */
import { hideLoader } from "action/loader/hideLoader";
import { openModal } from "action/modal/openModal";
import { setVehicleDetails } from "action/utils/setVehicleDetails";
import { RootState } from "interfaces/generics.type";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { createRef } from "react";
import { capitalize } from "../../util/lodash/capitalize";
import VehicleSelectorBase from "./VehicleSelectorBase";
import VehicleSelectorRefForm from "./VehicleSelectorRefForm";
import { YEAR_MAKE_MODEL } from "./constants";
import styles from "./styles/StyledVehicleSelectorForm.module.scss";

const propTypes = {
  selectionOrder: PropTypes.array,
  autoOpen: PropTypes.bool,
  autoScroll: PropTypes.bool,
  className: PropTypes.string,
  defaultYear: PropTypes.number,
  defaultMake: PropTypes.string,
  defaultModel: PropTypes.string,
  defaultEngine: PropTypes.string,
  onSelectVehicle: PropTypes.func.isRequired,
  onlyVehicleSelectorForm: PropTypes.bool,
  getFocusedFitmentNameHandler: PropTypes.func,
};

const defaultProps = {
  selectionOrder: YEAR_MAKE_MODEL,
  autoOpen: true,
  autoScroll: true,
};

/**
 * Main Form to select vehicle
 */
class VehicleSelectorForm extends VehicleSelectorBase {
  vehicleSelectCompactRef: any;

  vehicleSelectNextAttributeRef: any;

  vehicleSelectMakeRef: any;

  vehicleSelectModelRef: any;

  vehicleSelectYearRef: any;

  vehicleSelectEngineRef: any;

  constructor(props: any) {
    super(props);
    this.vehicleSelectYearRef = createRef();
    this.vehicleSelectMakeRef = createRef();
    this.vehicleSelectModelRef = createRef();
    this.vehicleSelectEngineRef = createRef();
    this.vehicleSelectNextAttributeRef = createRef();
    this.vehicleSelectCompactRef = createRef();
    this.vehicleSelectorFormRef = createRef();
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  componentDidMount() {
    const { autoFocus, focusEl } = this.props;

    const refMap = {
      make: this.vehicleSelectMakeRef,
      model: this.vehicleSelectModelRef,
      year: this.vehicleSelectYearRef,
      engine: this.vehicleSelectEngineRef,
    };
    window.addEventListener("click", this.handleOutsideClick);

    if (!["make", "model", "year", "engine"].includes(focusEl)) {
      refMap[focusEl] = this.vehicleSelectNextAttributeRef;
    }
    if (autoFocus && focusEl) {
      const interval = setInterval(() => {
        if (this.vehicleSelectCompactRef.current) {
          clearInterval(interval);
          this.vehicleSelectCompactRef.current.openNext(focusEl);
        } else if (refMap[focusEl].current) {
          // console.log("ref", focusEl, refMap[focusEl].current);
          // console.log("plural", refMap[focusEl].current.refs);
          // console.log("select", refMap[focusEl].current.refs.select);
          // console.log("more ref", refMap[focusEl].current.refs.select.refs);
          // console.log("select ref", refMap[focusEl].current.refs.select.select);
          if (refMap[focusEl].current.selectRef.current.props.options.length) {
            clearInterval(interval);
            refMap[focusEl].current.selectRef.current.onMenuOpen();
            refMap[focusEl].current.selectRef.current.focus();
            // refMap[focusEl].current.refs.select.select.onInputFocus();
            // refMap[focusEl].current.refs.select.input.focus();
          }
        }
      }, 100);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.handleOutsideClick);
  }

  // when user navigates via back button on mobile. Autofocus will work via componentDidUpdate as it's already mounted
  // 1993-1997-ford-f700-repair-sleeve-fel-pro-16274 -> similar product -> product page -> back button
  // componentDidUpdate(prevProps: any) {
  //   const { autoFocus, focusEl, garage } = this.props;
  //   const { isLoading } = garage;
  //   if (focusEl !== prevProps.focusEl || autoFocus !== prevProps.autoFocus) {
  //     if (focusEl && autoFocus && !isLoading) {
  //       this.vehicleSelectCompactRef.current.openNext(focusEl);
  //     }
  //   }
  // }

  handleOutsideClick(e) {
    const { handleFOBlur } = this.props;
    const { nextAttribute, vehicle } = this.state;
    const { current } = this.vehicleSelectorFormRef;
    if (current && nextAttribute && handleFOBlur && this.props.selectedId !== "vehicleSelector") {
      if (!current.contains(e.target)) {
        handleFOBlur(vehicle);
      } else {

      }
    }
  }

  onCompleteYearRequest(model: any, data: any, next: any) {
    if (this.props.autoOpen) this.openNext(next);
    this.setState({ [`loading${capitalize(next)}`]: false });
  }

  onCompleteMakeRequest(make: any, data: any, next: any, nextTitle: string) {
    if (this.props.autoOpen) this.openNext(next, nextTitle);
    this.setState({ [`loading${capitalize(next)}`]: false });
  }

  onCompleteModelRequest(model: any, data: any, next: any) {
    if (this.props.autoOpen) this.openNext(next);
    this.setState({ [`loading${capitalize(next)}`]: false });
  }

  openNext(next: any, nextTitle: string) {
    // eslint-disable-next-line no-nested-ternary
    if (this.props.getFocusedFitmentNameHandler) {
      this.props.getFocusedFitmentNameHandler(next, nextTitle);
    }

    const refMap = {
      make: this.vehicleSelectMakeRef,
      model: this.vehicleSelectModelRef,
      year: this.vehicleSelectYearRef,
      engine: this.vehicleSelectEngineRef,
    };

    if (!["make", "model", "year", "engine"].includes(next)) {
      refMap[next] = this.vehicleSelectNextAttributeRef;
    }
    const { current } = refMap[next];
    if (current) {
      console.log(current);
      current.selectRef.current.onMenuOpen();
      // current.refs.select.focus();
      current.selectRef.current.onInputFocus();
    } else if (this.vehicleSelectCompactRef && this.vehicleSelectCompactRef.current) {
      this.vehicleSelectCompactRef.current.openNext(next);
    }
  }

  render() {
    const { selectionOrder } = this.state;
    const {
      category, className, focusEl, autoFocus, skipFitmentOptions, hideInlineVehicleSelector, setData,
      attributeTitle,
    } = this.props;

    return (
      <div
        className={`${className} ${styles.styled_vehicle_selector}`}
        ref={this.vehicleSelectorFormRef}
      >
        <VehicleSelectorRefForm
          vehicleSelectYearRef={this.vehicleSelectYearRef}
          vehicleSelectMakeRef={this.vehicleSelectMakeRef}
          vehicleSelectModelRef={this.vehicleSelectModelRef}
          vehicleSelectEngineRef={this.vehicleSelectEngineRef}
          vehicleSelectNextAttributeRef={this.vehicleSelectNextAttributeRef}
          vehicleSelectCompactRef={this.vehicleSelectCompactRef}
          selectionOrder={selectionOrder}
          category={category}
          state={this.state}
          handleFocus={this.handleFocus}
          handleSelect={this.handleSelect}
          focusEl={focusEl}
          autoFocus={autoFocus}
          skipFitmentOptions={skipFitmentOptions}
          hideInlineVehicleSelector={hideInlineVehicleSelector}
          setData={setData}
          postalCode={this.props.postalCode}
          attributeTitle={attributeTitle}
          required={this.props.required}
        />
      </div>
    );
  }
}

VehicleSelectorForm.propTypes = propTypes;

VehicleSelectorForm.defaultProps = defaultProps;

const VehicleSelectorFormWithRouter = (props) => {
  const router = useRouter();
  const garage = useSelector((state: RootState) => state.garage);
  const { selectedId } = useSelector((state: RootState) => state.modal);
  const utils = useSelector((state: RootState) => state.utils);
  const { postalCode } = useSelector((state: RootState) => state.shoppingCart);
  const dispatch = useDispatch();

  return (
    <VehicleSelectorForm
      {...props}
      router={router}
      garage={garage}
      selectedId={selectedId}
      utils={utils}
      postalCode={postalCode}
      setVehicleDetails={(response) => dispatch(setVehicleDetails(response))}
      hideLoader={() => dispatch(hideLoader())}
      openModal={(selectedId, data) => dispatch(openModal(selectedId, data))}
    />
  );
};

export default VehicleSelectorFormWithRouter;
